import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

/**
 * Genera una lista desplegable para estructura de caracteres definida.
 *
 * Cualquier otra propiedad proporcionada sera controlada por el elemento raiz [TextField](https://material-ui.com/api/text-field/).
 */
function EstructuraField({
   value,
   onValueChange,
   defaultSelected,
   estructura,
   caracter,
   separador,
   ...other
}) {
   //Genear elementos a seleccionar
   const [lista, setlista] = useState([]);
   useEffect(() => {
      if (estructura && caracter) {
         const estructuraString = estructura.toString();
         let labelParcial = '';
         let valueParcial = 0;
         let nuevaLista = [];
         let listaChar = [];
         for (let inxChar = 0; inxChar < estructuraString.length; inxChar++) {
            const nroCaracteres = parseInt(estructuraString[inxChar]);
            if (!isNaN(nroCaracteres) && nroCaracteres > 0) {
               listaChar = Array(nroCaracteres).fill(caracter);
               if (inxChar === 0) {
                  labelParcial = listaChar.join('');
                  valueParcial = nroCaracteres;
               } else {
                  labelParcial = `${labelParcial}${separador}${listaChar.join('')}`;
                  valueParcial = valueParcial + nroCaracteres;
               }
               nuevaLista.push({label: labelParcial, value: valueParcial});
            }
         }
         setlista(nuevaLista);
         if (!value && defaultSelected && nuevaLista.length > 0) {
            onValueChange({
               target: {
                  name: other.name,
                  value: nuevaLista[0].value
               }
            });
         }
      }
   }, [estructura, caracter, separador]);

   return (
      <TextField {...other} select value={value || -1} onChange={onValueChange}>
         {lista.map((option) => (
            <MenuItem key={option.value} value={option.value}>
               {option.label}
            </MenuItem>
         ))}
      </TextField>
   );
}
EstructuraField.propTypes = {
   /**
    * Valor del estado del componente.
    */
   value: PropTypes.number,
   /** Accion a ejecutar cuando se modifica el `value`, con la siguiente firma:
    *
    * - `event`: object, event.target.value (number).
    * */
   onValueChange: PropTypes.func.isRequired,
   /**
    * Estructura de caracteres: 211 -> XX-X-X
    */
   estructura: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
   /**
    * Caracter que representara los caracteres de la lista.
    */
   caracter: PropTypes.string,
   /**
    * Separador de caracteres.
    */
   separador: PropTypes.string,
   /**
    * Si es __true__ el primer elemento generado de estructura sera elegido.
    */
   defaultSelected: PropTypes.bool,
};
EstructuraField.defaultProps = {
   defaultSelected: true,
   caracter: 'X',
   separador: '-'
};
export default EstructuraField;
